<template>
    <div>
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item >首页</el-breadcrumb-item>
            <el-breadcrumb-item style="margin-bottom:20px">数据查询</el-breadcrumb-item>
        </el-breadcrumb>
        
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="设备" name="1">
                <el-form :inline="true" :model="formInline" class="user-search">
                    <el-form-item label="设备sn码：">
                        <el-input size="small" v-model="formInline.machineId" :disabled="editFlag" placeholder="设备sn码"></el-input>
                    </el-form-item>
                    <el-form-item label="一级代理商" >
                        <el-select v-model="formInline.bindDistributorId" @change="FirstLevelAgentChange" placeholder="请选择">
                            <el-option
                            v-for="item in FirstLevelAgentOptions"
                            :key="item.id"
                            :label="item.nickname"
                            :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="二级代理商" v-if="formInline.bindDistributorId != ''">
                        <el-select v-model="formInline.secDistributorId" @change="SecondaryAgentChange" placeholder="请选择">
                            <el-option
                            v-for="item in SecondaryAgentOptiens"
                            :key="item.id"
                            :label="item.nickname"
                            :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="商家" v-if="formInline.secDistributorId != ''">
                        <el-select v-model="formInline.bindStoreId" placeholder="请选择">
                            <el-option
                            v-for="item in BusinessUserOptions"
                            :key="item.id"
                            :label="item.nickname"
                            :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="设备状态：">
                        <el-select v-model="formInline.inventoryStatus" placeholder="请选择">
                            <el-option label="全部" value=""></el-option>
                            <el-option label="未出库" value="0"></el-option>
                            <el-option label="已出库" value="1"></el-option>
                            <el-option label="故障" value="2"></el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="">
                        <el-button size="small" type="primary" @click="search">搜索</el-button>
                        <el-button size="small" @click="empty">重置</el-button>
                        <!-- <el-button size="small" type="primary" @click="addClick">创建总经销商</el-button> -->
                    </el-form-item>
                </el-form>
                <el-table size="small" :data="listData" max-height="600" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
                    <el-table-column  prop="machineId" label="设备sn码" ></el-table-column>
                    <el-table-column  prop="nickname" label="入库时间" >
                        <template slot-scope="scope">
                            <div>{{scope.row.createdAt|timestampToTime}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column  prop="inventoryStatus" label="出库状态" >
                        <template slot-scope="scope">
                            <div v-if="scope.row.inventoryStatus == 0">未出库</div>
                            <div v-if="scope.row.inventoryStatus == 1">已出库</div>
                            <div v-if="scope.row.inventoryStatus == 2">故障</div>
                        </template>
                    </el-table-column>
                    <el-table-column  prop="bindDistributorName" label="绑定一级代理" ></el-table-column>
                    <el-table-column  prop="secDistributorName" label="绑定二级代理" ></el-table-column>
                    <el-table-column  prop="bindStaffName" label="绑定代理商员工" ></el-table-column>
                    <el-table-column  prop="bindStoreName" label="绑定商家" ></el-table-column>
                    <el-table-column align="center" label="操作" >
                        <template slot-scope="scope">
                        <!-- <el-button size="mini" type="text" v-if="activeName == 1" v-preventReClick @click="revokeClick(scope.$index, scope.row)">替换设备</el-button> -->
                        <el-button size="mini" type="text" v-if="activeName == 1 && scope.row.inventoryStatus != 2" v-preventReClick @click="handleEdit(scope.$index, scope.row)">查看详情</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <!-- 分页组件 -->
                <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
            </el-tab-pane>
            <el-tab-pane label="商家" name="2">
                <!-- 搜索筛选 -->
                <el-form :inline="true" :model="formInline" class="user-search">
                    <el-form-item label="商家名称">
                        <el-input size="small" v-model="formInline.name" :disabled="editFlag" placeholder="昵称"></el-input>
                    </el-form-item>
                    <el-form-item label="商家注册手机号">
                        <el-input size="small" v-model="formInline.phone" :disabled="editFlag" placeholder="手机号"></el-input>
                    </el-form-item>
                    <el-form-item label="是否认证：">
                        <el-select v-model="formInline.attestation" placeholder="请选择">
                            <el-option label="全部" value=""></el-option>
                            <el-option label="否" value="0"></el-option>
                            <el-option label="是" value="1"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="一级代理商" >
                        <el-select v-model="formInline.bindDistributorId" @change="FirstLevelAgentChange" placeholder="请选择">
                            <el-option
                            v-for="item in FirstLevelAgentOptions"
                            :key="item.id"
                            :label="item.nickname"
                            :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="二级代理商" v-if="formInline.bindDistributorId != ''">
                        <el-select v-model="formInline.secDistributorId" @change="SecondaryAgentChange" placeholder="请选择">
                            <el-option
                            v-for="item in SecondaryAgentOptiens"
                            :key="item.id"
                            :label="item.nickname"
                            :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="">
                        <el-button size="small" type="primary" @click="search">搜索</el-button>
                        <el-button size="small" @click="empty">重置</el-button>
                        <!-- <el-button size="small" type="primary" @click="addClick">创建总经销商</el-button> -->
                    </el-form-item>
                </el-form>
                <el-table size="small" :data="listData" max-height="600" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
                    <el-table-column  prop="nickname" label="商家名称" ></el-table-column>
                    <el-table-column show-overflow-tooltip prop="phone" label="商家注册手机号" ></el-table-column>
                    <el-table-column  prop="attestation" label="是否认证" >
                        <template slot-scope="scope">
                            <div>{{scope.row.attestation == 1?'已认证':'未认证'}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip prop="bindMachineNum" label="绑定机器" ></el-table-column>
                    <el-table-column  prop="createdAt" label="注册时间">
                        <template slot-scope="scope">
                            <div>{{scope.row.createdAt|timestampToTime}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column  prop="distributorName" label="绑定一级代理" ></el-table-column>
                    <el-table-column  prop="secDistributorName" label="绑定二级代理" ></el-table-column>
                    <el-table-column align="center" label="操作">
                        <template slot-scope="scope">
                        <el-button size="mini" type="text" v-preventReClick @click="businessDetails(scope.$index, scope.row)">查看详情</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <!-- 分页组件 -->
                <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
            </el-tab-pane>
            <el-tab-pane label="收益统计" name="4">
                <!-- 搜索筛选 -->
                <el-form :inline="true" :model="incomeForm" class="user-search">
                    <el-form-item label="订单编号">
                        <el-input size="small" v-model="incomeForm.id" :disabled="editFlag" placeholder="订单编号"></el-input>
                    </el-form-item>
                    <el-form-item label="用户手机号">
                        <el-input size="small" v-model="incomeForm.phone" :disabled="editFlag" placeholder="手机号"></el-input>
                    </el-form-item>
                    <el-form-item label="业务类型">
                        <el-select v-model="incomeForm.flag" placeholder="请选择">
                            <el-option label="全部" value=""></el-option>
                            <el-option label="共享扫码桌费" value="共享"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="下单时间" >
                        <el-date-picker
                            format="yyyy 年 MM 月 dd 日"
                            value-format="yyyy-MM-dd"
                            @change="daterangeChange"
                            v-model="dateTime"
                            type="daterange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="角色" >
                        <el-select v-model="incomeForm.roleType" @change="roleTypeChange" placeholder="请选择">
                            <el-option label="全部" value=""></el-option>
                            <el-option label="一级代理" value="1"></el-option>
                            <el-option label="二级代理" value="2"></el-option>
                            <el-option label="商家" value="3"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="一级代理" v-if="incomeForm.roleType == 1">
                        <el-select v-model="incomeForm.distributorid"  placeholder="请选择">
                            <el-option
                            v-for="item in userData"
                            :key="item.id"
                            :label="item.nickname"
                            :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="二级代理" v-if="incomeForm.roleType == 2">
                        <el-select v-model="incomeForm.secid" placeholder="请选择">
                            <el-option
                            v-for="item in userData"
                            :key="item.id"
                            :label="item.nickname"
                            :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="商家" v-if="incomeForm.roleType == 3">
                        <el-select v-model="incomeForm.buid"  placeholder="请选择">
                            <el-option
                            v-for="item in userData"
                            :key="item.id"
                            :label="item.nickname"
                            :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="设备sn码">
                        <el-input size="small" v-model="incomeForm.machineid"  placeholder="设备sn码"></el-input>
                    </el-form-item>
                    <el-form-item label="">
                        <el-button size="small" type="primary" @click="search">搜索</el-button>
                        <el-button size="small" @click="incomeFormEmpty">重置</el-button>
                        <el-button size="small" type="primary" @click="ExportClick">导出</el-button>
                        <!-- <el-button size="small" type="primary" @click="addClick">创建总经销商</el-button> -->
                    </el-form-item>
                </el-form>
                <el-table size="small" :data="listData" max-height="600" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
                    <el-table-column  prop="id" label="订单编号" ></el-table-column>
                    <el-table-column show-overflow-tooltip prop="flag" label="业务类型" ></el-table-column>
                    <el-table-column  prop="user_phone" label="下单用户手机号" ></el-table-column>
                    <el-table-column show-overflow-tooltip prop="created_at" label="下单时间" ></el-table-column>
                    <el-table-column  prop="order_amount" label="下单金额" ></el-table-column>
                    <el-table-column  prop="amount" label="实付金额" ></el-table-column>
                    <el-table-column  prop="pay_type" label="支付方式" >
                        <template slot-scope="scope">
                            <div v-if="scope.row.pay_type == 2">微信</div>
                            <div v-if="scope.row.pay_type == 3">支付宝</div>
                        </template>
                    </el-table-column>
                    <el-table-column  prop="distributor_name" label="一级代理" ></el-table-column>
                    <el-table-column  prop="store_name" label="二级代理" ></el-table-column>
                    <el-table-column  prop="business_user_name" label="商家名称" ></el-table-column>
                    <!-- <el-table-column align="center" label="操作">
                        <template slot-scope="scope">
                        <el-button size="mini" type="text" v-preventReClick @click="businessDetails(scope.$index, scope.row)">查看详情</el-button>
                        </template>
                    </el-table-column> -->
                </el-table>
                <!-- 分页组件 -->
                <Pagination v-bind:child-msg="pageparm" @callFather="incomeCallFather"></Pagination>
            </el-tab-pane>
            <el-tab-pane label="错误码" name="3">
                <el-table size="small" :data="listData" highlight-current-row border  style="width: 100%;">
                    <el-table-column  prop="errCode" label="错误码" >
                    </el-table-column>
                    <el-table-column show-overflow-tooltip prop="errMessage" label="含义" >
                    </el-table-column>
                    <!-- <el-table-column align="center" label="操作" >
                        <template slot-scope="scope">
                        <el-button type="text" v-preventReClick @click="handleEdit(scope.row)">编辑</el-button>
                        <el-button type="text" v-preventReClick @click="delClick(scope.row)">删除</el-button>
                        </template>
                    </el-table-column> -->
                </el-table>
            </el-tab-pane>
        </el-tabs>
        
        <!-- 详情 -->
        <el-dialog title="设备详情" :visible.sync="detailsFlag" width="35%" @click="closeDialog">
            <el-descriptions class="margin-top" title="入库信息" :column="2" :size="size">
                <el-descriptions-item label="入库时间">{{ storageOrder.createdAt|timestampToTime}}</el-descriptions-item>
                <el-descriptions-item label="操作人">{{storageOrder.createName}}</el-descriptions-item>
                <el-descriptions-item label="入库单号">{{ storageOrder.id}}</el-descriptions-item>
            </el-descriptions>

            <el-descriptions style="margin-top: 20px;" class="margin-top" title="销售信息" v-if="saleOrder.price != undefined" :column="2" :size="size">
                <el-descriptions-item label="销售价格">{{saleOrder.price }}</el-descriptions-item>
                <el-descriptions-item label="销售人">{{saleOrder.createName }}</el-descriptions-item>
                <el-descriptions-item label="销售时间">{{saleOrder.createdAt|timestampToTime }}</el-descriptions-item>
                <el-descriptions-item label="采购单号">{{saleOrder.id }}</el-descriptions-item>
            </el-descriptions>

            <el-descriptions style="margin-top: 20px;" class="margin-top" v-if="machine.inventoryStatus == 1" title="出库信息" :column="2" :size="size">
                <el-descriptions-item label="状态">
                    <div v-if="machine.inventoryStatus == 1">已出库</div>
                    <div v-if="machine.inventoryStatus == 0">未出库</div>
                    <div v-if="machine.inventoryStatus == 2">故障</div>
                </el-descriptions-item>
                <el-descriptions-item label="出库单号">{{outOrder.id}}</el-descriptions-item>
                <el-descriptions-item label="创建出库时间">{{saleOrder.createdAt|timestampToTime }}</el-descriptions-item>
                <el-descriptions-item label="出库时间">{{saleOrder.updatedAt|timestampToTime }}</el-descriptions-item>
            </el-descriptions>

            <el-descriptions style="margin-top: 20px;" class="margin-top" title="注册信息" :column="2" :size="size">
                <el-descriptions-item label="注册状态">{{machine.bindStoreName == undefined?'未注册':'已注册'}}</el-descriptions-item>
                <el-descriptions-item label="商户">{{ machine.bindStoreName }}</el-descriptions-item>
                <el-descriptions-item label="注册时间">{{machine.activatedAt|timestampToTime}}</el-descriptions-item>
            </el-descriptions>

            <el-descriptions style="margin-top: 20px;" class="margin-top" title="经销商信息" :column="2" :size="size">
                <el-descriptions-item label="绑定经销商">{{machine.bindDistributorName}}</el-descriptions-item>
                <el-descriptions-item label="绑定经销商员工">{{ machine.bindStaffName }}</el-descriptions-item>
            </el-descriptions>

            <el-descriptions style="margin-top: 20px;" class="margin-top" v-if="machine.inventoryStatus == 1" title="系统模式" :column="1" :size="size">
                <el-descriptions-item label="设置设备系统模式管理权限">
                    <el-tag size="small" v-if="machine.systemModeOperator == 1">由平台设置</el-tag>
                    <el-tag size="small" v-else>由经销商设置</el-tag>
                </el-descriptions-item>
                <el-descriptions-item label="限制设备只能使用以下系统">
                    <el-tag size="small" v-if="machine.systemModeRangeObject.systemMode1 == true">免费模式</el-tag>
                    <el-tag size="small" v-if="machine.systemModeRangeObject.systemMode2 == true">电控模式</el-tag>
                    <el-tag size="small" v-if="machine.systemModeRangeObject.systemMode3 == true">共享模式</el-tag>
                </el-descriptions-item>
                <el-descriptions-item label="设置设备当前的系统">
                    <el-tag size="small" v-if="machine.systemMode == 1">免费模式</el-tag>
                    <el-tag size="small" v-if="machine.systemMode == 2">电控模式</el-tag>
                    <el-tag size="small" v-if="machine.systemMode == 3">共享模式</el-tag>
                </el-descriptions-item>
            </el-descriptions>

            <el-descriptions style="margin-top: 20px;" class="margin-top" title="设备信息" :column="2" :size="size">
                <el-descriptions-item label="sn码">{{ machine.machineId }}</el-descriptions-item>
            </el-descriptions>

            <el-descriptions style="margin-top: 20px;" v-if="replaceRecords.length != 0" class="margin-top" title="设备替换记录" :column="2" :size="size">
                <el-descriptions-item label="记录">
                    <el-table size="small" :data="replaceRecords" max-height="600" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
                        <el-table-column  prop="oldMachineId" label="原设备sn码" ></el-table-column>
                        <el-table-column  prop="newMachineId" label="新设备sn码" ></el-table-column>
                        <el-table-column  prop="createdAt" label="替换时间" >
                            <template slot-scope="scope">
                                <div>{{scope.row.createdAt|timestampToTime}}</div>
                            </template>
                        </el-table-column>
                        <el-table-column  prop="createdAt" label="操作人">
                            <template slot-scope="scope">
                                <div>{{scope.row.createdAt|timestampToTime}}</div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="remark" label="备注"></el-table-column>
                    </el-table>
                </el-descriptions-item>
            </el-descriptions>
        </el-dialog>


        <!-- 详情 -->
        <el-dialog title="商家详情" :visible.sync="businessDetailsFlag" width="30%" @click="businessDialog">
            <el-tabs type="border-card" v-model="businessName">
                <el-tab-pane label="基本信息" name="information">
                    <el-descriptions :column="1">
                        <el-descriptions-item label="商家名称">{{ editForm.nickname }}</el-descriptions-item>
                        <el-descriptions-item label="注册手机号">{{ editForm.phone }}</el-descriptions-item>
                        <el-descriptions-item label="注册时间">{{ editForm.createdAt|timestampToTime }}</el-descriptions-item>
                        <el-descriptions-item label="绑定经销商">{{ editForm.distributorName }}</el-descriptions-item>
                        <el-descriptions-item label="绑定经销商员工">{{ editForm.staffName }}</el-descriptions-item>
                        <el-descriptions-item label="分成比例">商家将从订单收益中（扣完手续费）分得{{ editForm.division }}%</el-descriptions-item>
                    </el-descriptions>
                </el-tab-pane>
                <el-tab-pane label="认证信息" name="attestation">
                    <el-switch
                        v-model="status"
                        active-text="已认证"
                        inactive-text="未认证"
                        :active-value="1"
                        :inactive-value="0"
                        @change="authenticaChange"
                        >
                        </el-switch>
                </el-tab-pane>
            </el-tabs>
        </el-dialog>
        <a v-show="false"></a>
</div>
</template>
<script>
import Pagination from '../../components/Pagination'
import { queryLoadMachineList ,queryLoadBusinessUserList, getMachine , updateMachineMode 
    ,replaceMachine , restoreMachine ,loadMachineReplaceList , 
    loadErrorList ,loadBusinessUserList ,storeSelect , loadMachineList  , payorderList ,
    getStoreUserList , payorderExport } from '../../api/userMG'
export default {
    data(){
        return{
            businessDetailsFlag:false,
            businessName:'',
            outOrder:{},
            saleOrder:{},
            replaceRecords:[],
            systemModeOperator:'',
            systemModeRange:{
                systemMode1:true,
                systemMode2:true,
                systemMode3:true,
            },
            systemMode:'',
            revokeFlag:false,
            addDeviceForm:{
                machineId:''
            },
            storageOrder:{},
            machine:{},
            machineIdList:[],
            id:'',
            bindingFlag:false,
            activeName:"1",
            detailsFlag:false,
            options:[
                {
                value: '1',
                label: '上架'
                }, {
                value: '0',
                label: '下架'
                },
            ],
            editForm:{},
            editFormVisible:false,
            formInline: {
                page: 1,
                limit: 10,
                name:'',
                phone:'',
                attestation:'',
                bindDistributor:'',
                bindDistributorName:'',
                bindStaff:'',
                bindStaffName:'',
                bindStore:'',
                bindStoreName:'',
                machineId:'',
                inventoryStatus:'',
                bindDistributorId:'',
                secDistributorId:'',
                bindStoreId:'',
            },
            incomeForm:{
                id:'',
                phone:'',
                flag:'',
                begintime:"",
                endtime:'',
                distributorid:'',
                secid:'',
                buid:'',
                machineid:'',
                page:1,
                limit:10,
                roleType:''
            },
            machineData:[],
            listData: [{
                url:'https://thirdwx.qlogo.cn/mmopen/vi_32/8kKUTuTsoibsLSHPAXfUAjX7zPssdyWk8CorQicic8gzHHuu517RcdXEhKFtIqvNyR0APLeyPiaqn6iaGfWzJp4Er5Q/132',
                sort:'1',
                status:0,
            }], //用户数据
            // 分页参数
            pageparm: {
                currentPage: 1,
                pageSize: 10,
                total: 10
            },
            machineId:'',
            id:'',
            maintenanceFlag:false,
            remark:"",
            newEquipmentId:'',
            FirstLevelAgentOptions:[],
            BusinessUserOptions:[],
            SecondaryAgentOptiens:[],
            userData:[],
            dateTime:[]
        }
    },
    components: {
        Pagination
    },
    created(){
        this.getdata()
        this.storeSelect()
    },
    methods:{
        ExportClick(){
            window.open(`/yunyue-houtai/payorder/export?params=${encodeURI(JSON.stringify(this.incomeForm))}`)
        },
        daterangeChange(e){
            console.log(e)
            if(e == null){
                this.incomeForm.begintime = ''
                this.incomeForm.endtime = ''
            }else {
                this.incomeForm.begintime = e[0]
                this.incomeForm.endtime = e[1]
            }
        },
        roleTypeChange(e){
            this.incomeForm.distributorid = ''
            this.incomeForm.secid = ''
            this.incomeForm.buid = ''
            if(e == 1){
                getStoreUserList({
                    userType:1
                }).then(res=>{
                    this.userData = res.storeUsers
                })
            }else if(e == 2){
                getStoreUserList({
                    userType:2
                }).then(res=>{
                    this.userData = res.storeUsers
                })
            }else if(e == 3){
                loadBusinessUserList({
                    page:1,
                    pageSize:1000
                }).then(res=>{
                    this.userData = res.pageInfo.list
                })
            }
            console.log(e)
        },
        // 设备列表查询接口
        SecondaryAgentChange(e){
            if(e == ''){
                this.formInline.bindStoreId = ''
            }else {
                loadBusinessUserList({
                    page:1,
                    pageSize:500,
                    secDistributorId:e
                }).then(res=>{
                    let data = [{
                        nickname:'全部',
                        id:''
                    }]
                    data = data.concat(res.pageInfo.list)
                    this.formInline.bindStoreId = ''
                    this.BusinessUserOptions = data
                })
            }
        },
        FirstLevelAgentChange(e){
            console.log(e)
            if(e == ''){
                this.formInline.secDistributorId = ''
                this.formInline.bindStoreId = ''
            }else {
                storeSelect({
                    pageSize:500,
                    page:1,
                    userType:2,
                    parentId:e
                }).then(res=>{
                    let data = [{
                        nickname:'全部',
                        id:''
                    }]
                    this.formInline.secDistributorId = ''
                    this.formInline.bindStoreId = ''
                    data = data.concat(res.data.dataList)
                    this.SecondaryAgentOptiens = data
                })
            }
        },
        storeSelect(){
            storeSelect({
                pageSize:500,
                page:1,
                userType:1,
            }).then(res=>{
                let data = [{
                    nickname:'全部',
                    id:''
                }]
                data = data.concat(res.data.dataList)
                this.FirstLevelAgentOptions = data
            })
        },


        businessDialog(){
            this.businessDetailsFlag = false
        },
        businessDetails(index , row){
            this.businessName = "information"
            this.businessDetailsFlag = true
            this.status = row.attestation
            this.editForm = row
        },
        maintenanceSubmit(){
            if(this.newEquipmentId == ''){
                this.$message.error('请输入新设备sn码')
            }else if(this.remark == ''){
                this.$message.error('请输入备注')
            }else{
                replaceMachine({
                    oldId:this.id,
                    oldMachineId:this.machineId,
                    newMachineId:this.newEquipmentId,
                    remark:this.remark,
                }).then(res=>{
                    if(res.success){
                        this.$message.success('操作成功')
                        this.newEquipmentId = '',
                        this.remark = ''
                        this.maintenanceFlag  = false
                        this.getdata()
                    }else{
                        this.$message.error(res.messages)
                    }
                })
            }

        },  
        maintenanceClick(index , row){
            this.machineId = row.machineId
            this.id = row.id
            this.maintenanceFlag = true
        },
        checkboxChange1(e){
            console.log(e)
            if(e == false && this.systemMode == 1){
                this.systemMode = ''
            }
        }, 
        checkboxChange2(e){
            console.log(e)
            if(e == false && this.systemMode == 2){
                this.systemMode = ''
            }
        },  
        checkboxChange3(e){
            console.log(e)
            if(e == false && this.systemMode == 3){
                this.systemMode = ''
            }
        },  
        systemModeInput(e){
            if(e == 1){
                this.systemModeRange = {
                    systemMode1:false,
                    systemMode2:false,
                    systemMode3:false,
                }
                this.systemMode = ''
            }else {
                this.systemModeRange = {
                    systemMode1:true,
                    systemMode2:true,
                    systemMode3:true,
                }
            }
        },
        editFormSubmit(){
            if(this.systemModeOperator == ''){
                this.$message.error('请选择设置设备系统管理权限')
            }else if(this.systemModeRange.systemMode1 == false && this.systemModeRange.systemMode2 == false && this.systemModeRange.systemMode3 == false){
                this.$message.error('请选择限制设备只能使用以下系统')
            }else if(this.systemMode == ''){
                this.$message.error('请选择设置设备当前的系统')
            }else {
                updateMachineMode({
                    id:this.machine.id,
                    systemMode:this.systemMode,
                    systemModeOperator:this.systemModeOperator,
                    systemModeRange:JSON.stringify(this.systemModeRange)
                }).then(res=>{
                    if(res.success){
                        this.$message.success('配置生效')
                        this.editFormVisible = false
                        this.systemModeRange = {
                            systemMode1:true,
                            systemMode2:true,
                            systemMode3:true,
                        }
                        this.systemMode = ''
                        this.systemModeOperator = ''
                    }else {
                        this.$message.error(res.messages)
                    }
                })
            }
        },
        modifiedModeClick(index , row){
            getMachine({
                id:row.id
            }).then(res=>{
                this.editFormVisible = true
                this.systemMode = res.machine.systemMode.toString()
                this.systemModeOperator = res.machine.systemModeOperator.toString()
                this.systemModeRange = res.machine.systemModeRangeObject
                this.storageOrder = res.storageOrder
                this.machine = res.machine
            })
        },  
        revokeSubmit(){
            
        },  
        revokeClick(index , row){
            this.revokeFlag = true
            this.id = row.id
        },
        addDeviceClick(){
            if(this.addDeviceForm.machineId == ''){
                this.$message.error('设备sn码不能为空')
            }else{
                let pushFlag = false
                for(let item of this.machineIdList){
                    if(item == this.addDeviceForm.machineId){
                        pushFlag = true
                    }
                }
                if(pushFlag == true){
                    this.$message.error('改设备sn码与已添加')
                }else{
                    this.machineIdList.push(this.addDeviceForm.machineId)
                    this.addDeviceForm.machineId = ''
                }
            }
        },
        deleteClick(index){
            this.machineIdList.splice(index , 1)
        },
        restoreClick(index , row){
            this.$confirm('是否确认恢复?', '恢复后，设备状态将由故障变为未出库', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
            // 删除
            restoreMachine({id:row.id}).then(res => {
                    if (res.success) {
                        this.$message({
                        type: 'success',
                        message: '解绑成功!'
                        })
                        this.getdata()
                    } else {
                        this.$message({
                        type: 'info',
                        message: res.messages
                        })
                    }
                })
                .catch(err => {
                    this.loading = false
                    this.$message.error('解绑失败，请稍后再试！')
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消恢复！'
                })
            })  
        },  
        handleEdit(index , row){
            getMachine({
                id:row.id
            }).then(res=>{
                if(res.success){
                    this.detailsFlag = true
                    this.storageOrder = res.storageOrder
                    this.machine = res.machine
                    this.replaceRecords = res.replaceRecords
                    this.outOrder = res.outOrder == undefined?{}:res.outOrder
                    this.saleOrder = res.saleOrder == undefined?{}:res.saleOrder
                }else{
                    this.$message.error(res.messages)
                }
                
            })
        },
        addClick(){
            this.editFormVisible = true
        },
        closeDialog(){
            this.editFormVisible = false
        },
        addBanner(){
            this.editFormVisible = true
        },
        empty(){
            this.formInline = {
                page: 1,
                limit: 10,
                name:'',
                phone:'',
                attestation:'',
                bindDistributor:'',
                bindDistributorName:'',
                bindStaff:'',
                bindStaffName:'',
                bindStore:'',
                bindStoreName:'',
                machineId:'',
                inventoryStatus:''
            }
            this.getdata()
        },
        incomeFormEmpty(){
            this.incomeForm = {
                id:'',
                phone:'',
                flag:'',
                begintime:"",
                endtime:'',
                distributorid:'',
                secid:'',
                buid:'',
                machineid:'',
                page:1,
                limit:10,
                roleType:''
            }
            this.dateTime = []
            this.getdata()
        },
        search(){
            this.formInline.page = 1
            this.formInline.limit = 10
            this.getdata()
        },
        handleClick(){
            
            if(this.activeName == 4){
                this.incomeForm = {
                    id:'',
                    phone:'',
                    flag:'',
                    begintime:"",
                    endtime:'',
                    distributorid:'',
                    secid:'',
                    buid:'',
                    machineid:'',
                    page:1,
                    limit:10,
                    roleType:''
                }
            }else {
                this.formInline = {
                    page: 1,
                    limit: 10,
                    name:'',
                    phone:'',
                    attestation:'',
                    bindDistributor:'',
                    bindDistributorName:'',
                    bindStaff:'',
                    bindStaffName:'',
                    bindStore:'',
                    bindStoreName:'',
                    machineId:'',
                    inventoryStatus:'',
                    bindDistributorId:'',
                    secDistributorId:'',
                    bindStoreId:'',
                }
            }
            this.listData = []
            this.getdata()
        },
        getdata(){
            if(this.activeName == 1){
                loadMachineList({
                    page:this.formInline.page,
                    pageSize:this.formInline.limit,
                    machineId:this.formInline.machineId,
                    bindDistributorId:this.formInline.bindDistributorId,
                    secDistributorId:this.formInline.secDistributorId,
                    bindStoreId:this.formInline.bindStoreId,
                    inventoryStatus:this.formInline.inventoryStatus
                }).then(res=>{
                    this.listData = res.pageInfo.list
                    this.pageparm.total = res.pageInfo.total
                })
            }else if(this.activeName == 2) {
                queryLoadBusinessUserList({
                    page:this.formInline.page,
                    pageSize:this.formInline.limit,
                    name:this.formInline.name,
                    phone:this.formInline.phone,
                    attestation:this.formInline.attestation,
                    distributorId:this.formInline.bindDistributorId,
                    secDistributorId:this.formInline.secDistributorId,
                }).then(res=>{
                    this.listData = res.pageInfo.list
                    this.pageparm.total = res.pageInfo.total
                })
            }else if(this.activeName == 4){
                payorderList(this.incomeForm).then(res=>{
                    this.listData = res.data.dataList
                    this.pageparm.total = res.data.total
                })
            }else {
                loadErrorList().then(res=>{
                    this.listData = res.errorList
                })
            }
        },
        // 分页插件事件
        callFather(parm) {
            this.formInline.page = parm.currentPage
            this.formInline.limit = parm.pageSize
            this.getdata(this.formInline)
        },
        incomeCallFather(parm){
            this.incomeForm.page = parm.currentPage
            this.incomeForm.limit = parm.pageSize
            this.getdata()
        }
    }
}
</script>
<style>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>


// WEBPACK FOOTER //
// src/views/queryData/index.vue